// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductCardSlot_wrapper__2nr8g"};